/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CriterionSchemaSource } from './criterionSchemaSource';

export interface CriterionSchema {
  id: string;
  position: number;
  label: string;
  description: string;
  source: CriterionSchemaSource;
  version: number;
  created_at: string;
  updated_at: string;
}
